import { Component, inject, Input, OnInit } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { ImportIndicator } from '../../../services/indicator/import-validator.service';
import { TagListComponent } from '../../molecules/tag-list/tag-list.component';
import { UnitComponent } from '../../atoms/unit/unit.component';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { CategoryStore } from '../../../stores/category/category.state';
import { ChipModule } from 'primeng/chip';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-indicator-import-list',
  standalone: true,
  imports: [
    NgIf,
    AccordionModule,
    NgForOf,
    TableModule,
    TagListComponent,
    UnitComponent,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    AlertStyleDirective,
    ChipModule,
    TagModule,
  ],
  templateUrl: './indicator-import-list.component.html',
  styleUrl: './indicator-import-ist.component.scss',
})
export class IndicatorImportListComponent implements OnInit {
  readonly categoryStore = inject(CategoryStore);
  @Input() items: ImportIndicator[] = [];
  @Input() severity = '';
  @Input() icon = '';
  itemsFiltered: ImportIndicator[] = [];

  /**
   * Initializes the component after Angular has finished initializing the component's input properties.
   * Sets the initial value of `itemsFiltered` equal to `items` when*/
  ngOnInit(): void {
    this.itemsFiltered = this.items;
  }

  /**
   * Updates the filtered list of items based on the provided search query.
   * If the search query is empty, the filtered list will contain all items.
   * Otherwise, it will filter items by checking if their `name` property includes the search query (case insensitive).
   *
   * @param {string} searchQuery - The search query used to filter the list of items.
   * @return {void} This method does not return a value.
   */
  updateList(searchQuery: string): void {
    if (!searchQuery.length) {
      this.itemsFiltered = this.items;
    } else {
      this.itemsFiltered = this.items.filter((item: ImportIndicator) => {
        return item.name.toLowerCase().includes(searchQuery.toLowerCase());
      });
    }
  }
}
